<button *ngIf="show" type="button" class="back-btn" aria-label="Back" (click)="goBack()">
  <svg-icon src="assets/icons/icon-back.svg" [svgStyle]="{'height': 'var(--bb-icon-h)', 'width': 'calc(var(--bb-icon-h) * 15 / 22)'}"></svg-icon>
</button>
